import { AxiosResponse } from 'axios';
import React, { useRef, useEffect, useState, ChangeEvent } from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import { DateObject } from "react-multi-date-picker";
import { OptionMapperHelper } from '../../helpers/OptionMapperHelper';
import { IIssuer } from "../../models/IIssuer";
import { ITransaction, ITransactionWebModelRequest } from "../../requests/ITransactionWebModelRequest";
import "./TransactionReport.scss"
import { TransactionService } from '../../services/TransactionService';
import { UtilService } from "../../services/UtilService";
import { allAcquirersFilters, allPaymentModesUru } from "../../models/TransactionReportConstants"
import { Option } from "../../models/Option"
import { WebCache } from "../../services/WebCache";
import ErrorsView from '../ErrorsView';
import TerminalLocation from "../TerminalLocationNew";
import DateField from '../controls/fields/dateFieldNew';
import NumericField from '../controls/fields/numericFieldNew';
import SelectField from '../controls/fields/selectFieldNew';
import TextField from '../controls/fields/textFieldNew';
import Page from '../containers/pageNew'
import FormFilter, { FilterBlock } from '../containers/form-filterNew';
import { DateHelper } from '../../helpers/DateHelperNew';
import NavigationTabLinksForTransactions from './NavigationTabLinksForTransactions';
import { TransactionColumns } from './TransactionsColumnsNew';
import { useMessages } from "../MessagesContext";
import { SmartTable } from '../table/SmartTable';
import { toast } from 'react-toastify';
import SideModal from '../containers/side-modal';
import DetailTransaction from './DetailTransaction';
import CouponIframe from '../coupons/couponIframe';
import Select, { components } from 'react-select';
import { ReactComponent as AuthorizationCodeSVG } from 'itd-common/assets/icons/authorization-code-filter.svg';
import { ReactComponent as CreditCardSVG } from 'itd-common/assets/icons/credit_card.svg';
import { ReactComponent as BatchSVG } from 'itd-common/assets/icons/icon-folder.svg';
import { ReactComponent as GrossAmountSVG } from 'itd-common/assets/icons/gross-amount-filter.svg';
import { ReactComponent as TicketSVG } from 'itd-common/assets/icons/ticket-filter.svg';
import { ReactComponent as CommerceSVG } from 'itd-common/assets/icons/commerce-number.svg';
import { ReactComponent as QrCodeSVG } from 'itd-common/assets/icons/qr_code.svg';

interface IProps {
    t: TFunction
}
interface IFilters {
    dateRange: Array<DateObject>,
    operationTypeFilter: string,
    initQuestionFilter: string,
    groupFilter: string,
    ticketFilter: string,
    batchFilter: string,
    transactionStateFilter: string,
    terminalFilter: string,
    authorizationCodeFilter: string,
    authTerminalFilter: string,
    amountFilter: string,
    amountToCustomerFilter: string,
    merchantFilter: string,
    transactionIdFilter: string
    cardNumberIdFilter: string,
    muIdFilter: string,
    paymentModeFilter: string,
    acquirerFilter: string,
    issuerFilter: string,
    departmentFilter: string,
    locationFilter: string,
    branchFilter: string,
    taxPayerFilter: string[],
    responseCodeSelected: string | null,
    currencySelected: string | null
}

let [fromDate, toDate] = DateHelper.buildDateRange();
const dateRange = [fromDate, toDate];
const emptyClearStates = { dateRange: dateRange, operationTypeFilter: "", initQuestionFilter: "", groupFilter: "", ticketFilter: "", batchFilter: "", transactionStateFilter: "", terminalFilter: "", authorizationCodeFilter: "", authTerminalFilter: "", amountFilter: "", amountToCustomerFilter: "", merchantFilter: "", transactionIdFilter: "", cardNumberIdFilter: "", muIdFilter: "", paymentModeFilter: "", acquirerFilter: "", issuerFilter: "", departmentFilter: "", locationFilter: "", branchFilter: "", taxPayerFilter: [], responseCodeSelected: "", currencySelected: "" };

const pageSize = 20;
const pageQuantity = 3
const pageUrl: string = window.location.href;
const maxDayRange: number = 15;
const T_PREFIX: string = 'pages.reportTransactions.';
const DEFAULT_COLUMNS: string[] = ["authDateTime", "terminal", "transactionType", "inputMode", "issuer", "acquirer", "state", "totalAmountForReport"];

const CurrentTransactionReport: React.FC<IProps> = ({ t }: IProps) => {
    const allTransactionStatesFilter = localStorage.getItem("_transactionStatesCode") ? JSON.parse(localStorage.getItem("_transactionStatesCode") as string) : [];
    const allResponseCodes = localStorage.getItem("_transactionResponseCode") ? JSON.parse(localStorage.getItem("_transactionResponseCode") as string) : [];
    const allOperationTypesFilters = localStorage.getItem("_transactionTypesCode") ? JSON.parse(localStorage.getItem("_transactionTypesCode") as string) : [];
    const buildPaymentModesSelectOptions = (): Array<Option> => {
        let respondCodes: Array<Option> = [
            { value: "", label: t("all"), key: "all" } as Option
        ];
        const allPaymentModes = allPaymentModesUru;
        const responseCodes: Array<HTMLOptionElement> = new OptionMapperHelper(t).buildSelectOptionsFromEnum(allPaymentModes, 'channel-') as Array<HTMLOptionElement>;
        respondCodes.push(...responseCodes);
        return respondCodes;
    }
    const [filters, setFilters] = useState<IFilters>(emptyClearStates);
    const [lastHistory, setLastHistory] = useState<string>("");
    const [shouldFetch, setShouldFetch] = useState(false);
    const [transactions, setTransactions] = useState<ITransaction[]>([]);
    const [errors,setErrors] = useState<string[]>([])
    const [mainPage, setMainPage] = useState<number>(0);
    const [showTransactionDetail, setShowTransactionDetail] = useState(false);
    const [currencies, setCurrencies] = useState<Option[]>(UtilService.getCurrencyOptions());
    const [showCouponModal, setShowCouponModal] = useState(false);
    const [ticket, setTicket] = useState<string>("");
    const [transactionDetail, setTransactionDetail] = useState<ITransaction>({} as ITransaction);
    const [currentIssuers, setCurrentIssuers] = useState<IIssuer[]>(WebCache.getAllIssuers());
    const [responseCodes, setResponseCodes] = useState<Option[]>(new OptionMapperHelper(t).buildTransactionSelectOptions(allResponseCodes, true))
    const [paymentModes, setPaymentModes] = useState<Option[]>(buildPaymentModesSelectOptions())
    const messages = useMessages();
    const terminalChildInstance = useRef<any>(null);
    const dateFieldRef = useRef<any>(null);
    const [activeSearchField, setActiveSearchField] = useState('amount');

    const getTransactionRequest = (all: boolean) => {
        const [fromDate, toDate] = filters.dateRange as Array<DateObject>;
        let from_year: number;
        let from_month: number;
        let from_day: number;
        let to_year: number;
        let to_month: number;
        let to_day: number;
        from_year = fromDate.year;
        from_month = fromDate.month.number;
        from_day = fromDate.day;
        to_year = toDate.year;
        to_month = toDate.month.number;
        to_day = toDate.day;

        const getIdOfFilter = (value: string) => {// Obtiene el id del filtro de transaccion seleccionado, este separado por "-"
            return value.split("-")[1];
        };

        const tranWebModel: ITransactionWebModelRequest = {
            From: new Date(from_year, from_month - 1,
                from_day,
                fromDate.hour - 3,
                fromDate.minute).toJSON(),
            To: new Date(to_year,
                to_month - 1,
                to_day,
                toDate.hour - 3,
                toDate.minute).toJSON(),
            Terminals: (filters.terminalFilter == null || filters.terminalFilter == "") ? [] : [filters.terminalFilter],
            TransactionState: (filters.transactionStateFilter == null || filters.transactionStateFilter == "") ? [] : filters.transactionStateFilter.split("-").map(Number),
            OperationType: (filters.operationTypeFilter == null) ? "" : (getIdOfFilter(filters.operationTypeFilter)),
            TerminalGroup: (filters.groupFilter == null || filters.groupFilter == "") ? "" : filters.groupFilter,
            InitQuestion: (filters.initQuestionFilter == null || filters.initQuestionFilter == "") ? "" : filters.initQuestionFilter,
            AuthTerminal: (filters.authTerminalFilter == null || filters.authTerminalFilter == "") ? "" : filters.authTerminalFilter,
            Amount: (filters.amountFilter == null || filters.amountFilter == "") ? "" : filters.amountFilter,
            AmountToCustomer: (filters.amountToCustomerFilter == null || filters.amountToCustomerFilter == "") ? "" : filters.amountToCustomerFilter,
            MerchantCodes: (filters.merchantFilter === null || filters.merchantFilter == "") ? [] : [filters.merchantFilter],
            AuthorizationCode: (filters.authorizationCodeFilter == null || filters.authorizationCodeFilter == "") ? "" : filters.authorizationCodeFilter,
            Issuer: (filters.issuerFilter == null || filters.issuerFilter == "0000") ? "" : filters.issuerFilter,
            Department: (filters.departmentFilter == null || filters.departmentFilter == "0000") ? "" : filters.departmentFilter,
            Location: (filters.locationFilter == null || filters.locationFilter == "0000") ? "" : filters.locationFilter,
            PayerTaxIds: filters.taxPayerFilter.includes("all") ? [] : filters.taxPayerFilter.filter(x => x.length > 0),
            Branch: (filters.branchFilter == null || filters.branchFilter == "0000") ? "" : filters.branchFilter,
            Acquirer: (filters.acquirerFilter == null || filters.acquirerFilter == "0000") ? "" : filters.acquirerFilter,
            TransactionId: (filters.transactionIdFilter == null || filters.transactionIdFilter == "") ? "" : filters.transactionIdFilter,
            CardNumber: (filters.cardNumberIdFilter == null || filters.cardNumberIdFilter == "") ? "" : filters.cardNumberIdFilter,
            MuId: (filters.muIdFilter == null || filters.muIdFilter == "") ? "" : filters.muIdFilter,
            TicketNumber: (filters.ticketFilter == null || filters.ticketFilter == "") ? "" : filters.ticketFilter,
            BatchNumber: (filters.batchFilter == null || filters.batchFilter == "") ? "" : filters.batchFilter,
            PaymentMode: (filters.paymentModeFilter == null || filters.paymentModeFilter == "") ? "" : filters.paymentModeFilter,
            Currency: (filters.currencySelected == null || filters.currencySelected == "") ? "" : filters.currencySelected,
            ResponseCode: (filters.responseCodeSelected == null || filters.responseCodeSelected == "") ? "" : (getIdOfFilter(filters.responseCodeSelected)),
            Skip: all ? 0 : (mainPage * pageSize * pageQuantity),
            Take: all ? 0 : ((pageSize * pageQuantity) + 1)
        };
        return tranWebModel;
    }

    const getTransactions = () => {
        TransactionService.getCurrentTransactions(getTransactionRequest(false)).then((response: AxiosResponse<ITransaction[]>) => {
            if (response == null || response.data == null || response.data.length == 0) {
                setTransactions([])
                setErrors([])
            }
            setTransactions(response.data)
            setErrors([])
        }).catch(error => {
            setErrors(error.response.data)
            setTransactions([])
            console.log('error:', error);
        }
        );
    }

    const getFromBuscar = () => {
        //validaciones del filtro fecha
        if (filters.dateRange.length < 2) {
            toast.error("El filtro periodo es obligatorio, seleccione un rango");
            return;
        }
        let dateFrom = DateHelper.dateObjectToDate(filters.dateRange[0]);
        let dateTo = DateHelper.dateObjectToDate(filters.dateRange[1]);
        let diffDays = Math.round((dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24));
        if (diffDays > maxDayRange) {
            toast.error(`La busqueda no puede superar los ${maxDayRange} días`);
            return;
        }
        setMainPage(0);
        getTransactions();
        let date = DateHelper.buildLastHistoryDate(filters.dateRange[0] as DateObject);
        setLastHistory(date);
    }

    const clearFilters = () => {
        setFilters(emptyClearStates);
        setActiveSearchField('amount');
        //activo el limpiar filtros en ref de terminalLocation
        terminalChildInstance.current?.clearFilters();
    }

    const openRangeFilter = () => {
        dateFieldRef.current?.open();
    }
    //obtiene valores predeterminados cuando se hace clearFilters
    useEffect(() => {
        if (shouldFetch) {
            getFromBuscar();
            setShouldFetch(false); // Resetea la bandera
        }
    }, [filters, shouldFetch]);

    const getTicket = async (tranId: string, transactionType: string) => {
        try {
            const response: AxiosResponse<string> = await TransactionService.getTicket(tranId, transactionType);
            setTicket(response.data);
        } catch (error) {
            console.error("Error obteniendo el ticket:", error);
        }
    };
    const showTicket = async (tranId: string, transactionType: string) => {
        await getTicket(tranId, transactionType);
        setShowCouponModal(true);
    };

    const showMoreDetails = (transaction: ITransaction) => {
        setTransactionDetail(transaction);
        setShowTransactionDetail(true);
    }

    const handleShowCoupon = () => {
        getTicket(transactionDetail.id, transactionDetail.transactionType);
        setShowCouponModal(true);
    }

    const handleAcquirerFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        let acquirerId = event.target.value;
        setFilters({
            ...filters,
            acquirerFilter: acquirerId,
            issuerFilter: "0000"
        })
        setCurrentIssuers(WebCache.getAllIssuers())
    }

    const transactionColumns = TransactionColumns({
        t,
        showTicket,
        showMoreDetails,
        showCouponColumn: true
    });

    const buildIssuerSelectOptions = () => {
        let options: Array<HTMLOptionElement> = new OptionMapperHelper(t).buildSelectOptionsFromAnArrayWithDifferentInterface(currentIssuers, 'id', 'issuerName') as Array<HTMLOptionElement>;
        const todosIndex = options.findIndex(option => option.value === '0000');

        if (todosIndex !== -1) {
            const todosOption = options.splice(todosIndex, 1)[0];
            options = [todosOption, ...options];
        }
        options.sort((a, b) => {
            if (a.label === 'Todos') return -1;
            if (b.label === 'Todos') return 1;
            return a.label.localeCompare(b.label);
        });
        return options;
    }

    // mapea el campo elegido en el buscador rápido a la clave de filters que ya viaja al backend
    type QuickSearchFilterKey = 'amountFilter' | 'authorizationCodeFilter' | 'cardNumberIdFilter' | 'batchFilter' | 'ticketFilter' | 'merchantFilter' | 'muIdFilter';
    const searchFieldToFilterKey: Partial<Record<string, QuickSearchFilterKey>> = {
        amount: 'amountFilter',
        authorizationCode: 'authorizationCodeFilter',
        cardNumber: 'cardNumberIdFilter',
        batch: 'batchFilter',
        ticket: 'ticketFilter',
        merchant: 'merchantFilter',
        muId: 'muIdFilter'
    };

    const searchFieldOptions = [
        { value: 'amount', label: t(`${T_PREFIX}amount`) as string, icon: <GrossAmountSVG /> },
        { value: 'authorizationCode', label: t(`${T_PREFIX}authorizationCode`) as string, icon: <AuthorizationCodeSVG /> },
        { value: 'cardNumber', label: t(`${T_PREFIX}cardNumber`) as string, icon: <CreditCardSVG /> },
        { value: 'batch', label: t(`${T_PREFIX}batch`) as string, icon: <BatchSVG /> },
        { value: 'ticket', label: t(`${T_PREFIX}ticket`) as string, icon: <TicketSVG /> },
        { value: 'merchant', label: t(`${T_PREFIX}merchant`) as string, icon: <CommerceSVG/> },
        ...(WebCache.getCurrentUser()?.countryId === 1 ? [{ value: 'muId', label: t(`${T_PREFIX}muId`) as string, icon: <QrCodeSVG/> }] : [])
    ];

    const IconOption = (props: any) => (
        <components.Option {...props}>
            <span style={{ marginRight: 8 }}>{props.data.icon}</span>
            {props.data.label}
        </components.Option>
    );

    const SingleValue = (props: any) => (
        <components.SingleValue {...props}>
            <span style={{ marginRight: 8 }}>{props.data.icon}</span>
            {props.data.label}
        </components.SingleValue>
    );

    return (
        <Page>
            <>
                <div className="movements">
                    <div className="row">
                        <div className='col-md-9 p-0'>
                            <div className="col-md-12 box-title">
                                <h2>{t(`${T_PREFIX}title`)}</h2>
                            </div>
                            <div className="col-md-12">
                                <p className="description text-start">{t(`${T_PREFIX}description`)}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-lg-9 mt-2">
                                <NavigationTabLinksForTransactions></NavigationTabLinksForTransactions>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <ErrorsView errors={errors} />
                        </div>
                    </div>
                    <div className="row">
                        <FormFilter
                            onSubmit={() => getFromBuscar()}
                            model={[filters, setFilters]}
                            clear={() => clearFilters()}
                            hidden={UtilService.isMobilePlatform() ? true : false}
                            page={pageUrl}
                            emptyClearStates={emptyClearStates}
                        >
                            <>
                                <FilterBlock slot='primary' primaryClass="col-md-2" advancedClass="col-md-12 my-4 pt-2">
                                    <DateField attr="dateRange" label="period" range required={true} ref={dateFieldRef}></DateField>
                                </FilterBlock>
                                <TerminalLocation
                                    onReady={(inst) => { terminalChildInstance.current = inst; }}
                                    changeFilter={(taxPayerFilter, branchFilter, departmentFilter, locationFilter, departmentName, locationName, branchName, clientDocument) => {
                                        setFilters({
                                            ...filters,
                                            taxPayerFilter: taxPayerFilter,
                                            branchFilter: branchFilter,
                                            departmentFilter: departmentFilter,
                                            locationFilter: locationFilter,
                                        });
                                    }}
                                    filter={{
                                        taxPayerFilter: {
                                            value: filters.taxPayerFilter,
                                            advancedClass: "col-md-12 my-4",
                                            primaryClass: "col-md-2",
                                            slot: 'primary'
                                        },
                                        branchFilter: {
                                            value: filters.branchFilter,
                                            advancedClass: "col-md-12 my-4",
                                            primaryClass: "col-md-3",
                                            slot: 'advanced'
                                        },
                                        departmentFilter: {
                                            value: filters.departmentFilter,
                                            advancedClass: "col-md-12 my-4",
                                            primaryClass: "col-md-3",
                                            slot: 'advanced'
                                        },
                                        locationFilter: {
                                            value: filters.locationFilter,
                                            advancedClass: "col-md-12 my-4",
                                            primaryClass: "col-md-3",
                                            slot: 'advanced'
                                        },
                                        merchantDocument: {
                                            advancedClass: "col-md-12 my-4",
                                            primaryClass: "col-md-3",
                                            slot: "advanced"
                                        }
                                    }}
                                />
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <SelectField
                                        attr="operationTypeFilter"
                                        label={t(`${T_PREFIX}transactionType`)}
                                        options={new OptionMapperHelper(t).buildTransactionSelectOptions(
                                            allOperationTypesFilters,
                                            false
                                        )}
                                    />
                                </FilterBlock>
                                <FilterBlock slot='primary' primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                    <SelectField
                                        attr="transactionStateFilter"
                                        label={t(`${T_PREFIX}state`)}
                                        options={new OptionMapperHelper(t).buildTransactionSelectOptions(
                                            allTransactionStatesFilter,
                                            false,
                                            true
                                        )}
                                    />
                                </FilterBlock>
                                {WebCache.isUserUYU() && (
                                    <FilterBlock advancedClass="col-md-12 my-4">
                                        <SelectField
                                            attr="acquirerFilter"
                                            label={t(`${T_PREFIX}acquirer`)}
                                            options={new OptionMapperHelper(t).buildSelectOptionsFromEnum(
                                                allAcquirersFilters,
                                                'acquirer-'
                                            )}
                                            onChange={(event) => handleAcquirerFilterChange(event)}
                                        />
                                    </FilterBlock>
                                )}
                                <FilterBlock slot='primary' primaryClass='col-md-2' advancedClass="col-md-12 my-4">
                                    <SelectField
                                        attr="issuerFilter"
                                        label={t(`${T_PREFIX}issuer`)}
                                        options={buildIssuerSelectOptions()}
                                    />
                                </FilterBlock>
                                <FilterBlock slot='primary' primaryClass="col-md-6" advancedClass="col-md-12 my-4">
                                    <div className="d-flex align-items-center gap-2 extra-filter">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={searchFieldToFilterKey[activeSearchField] ? filters[searchFieldToFilterKey[activeSearchField]!] : ''}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                const key = searchFieldToFilterKey[activeSearchField];
                                                if (key) setFilters({ ...filters, [key]: e.target.value });
                                            }}
                                        />
                                        <Select
                                            options={searchFieldOptions}
                                            value={searchFieldOptions.find(o => o.value === activeSearchField)}
                                            onChange={(option: any) => setActiveSearchField(option.value)}
                                            components={{ Option: IconOption, SingleValue }}
                                            isSearchable={false}
                                            className="search-select-wrapper"
                                            classNamePrefix="custom-search-select"
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                        />
                                    </div>
                                </FilterBlock>
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="terminalFilter"
                                        label={t(`${T_PREFIX}terminal`)}
                                    />
                                </FilterBlock>
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="merchantFilter"
                                        label={t(`${T_PREFIX}merchant`)}
                                    />
                                </FilterBlock>
                                {WebCache.isUserUYU() && (
                                    <FilterBlock advancedClass="col-md-12 my-4">
                                        <TextField
                                            attr="authTerminalFilter"
                                            label={t(`${T_PREFIX}authTerminal`)}
                                        />
                                    </FilterBlock>
                                )}
                                {WebCache.isUserUYU() && (
                                    <FilterBlock advancedClass="col-md-12 my-4">
                                        <NumericField
                                            attr="amountToCustomerFilter"
                                            label={t(`${T_PREFIX}amountToCustomer`)}
                                        />
                                    </FilterBlock>
                                )}
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <NumericField
                                        attr="amountFilter"
                                        label={t(`${T_PREFIX}amount`)}
                                    />
                                </FilterBlock>
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="authorizationCodeFilter"
                                        label={t(`${T_PREFIX}authorizationCode`)}
                                    />
                                </FilterBlock>
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="transactionIdFilter"
                                        label={t(`${T_PREFIX}id`)}
                                    />
                                </FilterBlock>
                                {WebCache.isUserUYU() && (
                                    <>
                                        <FilterBlock advancedClass="col-md-12 my-4">
                                            <TextField
                                                attr="initQuestionFilter"
                                                label={t(`${T_PREFIX}initQuestion`)}
                                            />
                                        </FilterBlock>
                                        <FilterBlock advancedClass="col-md-12 my-4">
                                            <TextField
                                                attr="groupFilter"
                                                label={t(`${T_PREFIX}terminalGroup`)}
                                            />
                                        </FilterBlock>
                                    </>
                                )
                                }
                                {
                                    currencies.length > 1 &&
                                    <FilterBlock advancedClass="col-md-12 my-4">
                                        <SelectField
                                            attr="currencySelected"
                                            label={t(`${T_PREFIX}currency`)}
                                            options={currencies}
                                        />
                                    </FilterBlock>
                                }
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="cardNumberIdFilter"
                                        label={t(`${T_PREFIX}cardNumber`)}
                                    />
                                </FilterBlock>
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <SelectField
                                        attr="responseCodeSelected"
                                        label={t(`${T_PREFIX}responseCode`)}
                                        options={responseCodes}
                                    />
                                </FilterBlock>
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="ticketFilter"
                                        label={t(`${T_PREFIX}ticket`)}
                                    />
                                </FilterBlock>
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="batchFilter"
                                        label={t(`${T_PREFIX}batch`)}
                                    />
                                </FilterBlock>
                                <FilterBlock slot='primary' primaryClass='col-md-2' advancedClass="col-md-12 my-4">
                                    <SelectField
                                        attr="paymentModeFilter"
                                        label={t(`${T_PREFIX}paymentMode`)}
                                        options={paymentModes}
                                    />
                                </FilterBlock>
                            </>
                        </FormFilter>
                    </div>
                    <div className="row">
                        <SmartTable
                            data={transactions}
                            config={{
                                pageSize: pageSize,
                                blockSize: (pageSize * pageQuantity),
                                mode: "grid",
                                paginator: {
                                    quantity: pageQuantity,
                                    mainPage: mainPage,
                                    modifyMainPage: (value: number) => {
                                        setMainPage(mainPage + value);
                                        getTransactions();
                                    },
                                    pageRequest: {
                                        Skip: 0,
                                        Take: 0
                                    }
                                },
                                storageKey: 'smart-table:transactions',
                                defaultColumns: DEFAULT_COLUMNS,
                                debugMode: true,
                            }}
                            columnDefinitions={transactionColumns}
                            clearFilters={clearFilters}
                            openRangeFilter={openRangeFilter}
                            onFetchMore={getTransactions}
                        />
                    </div>
                    <>
                        <SideModal title={t(`${T_PREFIX}detailTransactionTitle`)} show={showTransactionDetail} onClose={() => setShowTransactionDetail(false)}>
                            <DetailTransaction transaction={transactionDetail} showCoupon={handleShowCoupon} t={t} isUserUYU={WebCache.isUserUYU()} />
                        </SideModal>
                        <SideModal title={t(`${T_PREFIX}coupon`)} backButton={true} width={"50vw"} show={showCouponModal} onClose={() => setShowCouponModal(false)}>
                            <CouponIframe couponHtml={ticket} />
                        </SideModal>
                    </>
                </div>
            </>
        </Page>
    )
};

export default withTranslation()(CurrentTransactionReport);